import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalDialog, modalDialogClasses } from '@gmm/ui';
import { idProps, ids as allIds } from '~/lib/constants';
import { Dropdown } from '~/lib/forms';
import { everyStateWithNone } from '~/lib/states';

import { useGeographicalState } from './useGeographicalState';

const ids = allIds.trainerSettings;
const fieldIdProps = idProps(ids.form.stateSelector);

interface Props {
  onClose: () => void;
  open: boolean;
}

const stateOptions = everyStateWithNone.map(state => ({
  label: state,
  value: state,
}));

export const TrainerSettingsModal: FC<Props> = ({ onClose, open }) => {
  const [t] = useTranslation(['trainerSettings']);
  const [state, setState] = useGeographicalState();

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setState(e.target.value);
    onClose();
  };

  return (
    <ModalDialog
      content={
        <Dropdown
          {...fieldIdProps}
          fullWidth
          label={t('trainerSettings:stateSelector')}
          name="state"
          onChange={handleChange}
          options={stateOptions}
          value={state ?? ''}
        />
      }
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={open}
      sx={{ [`& .${modalDialogClasses.content}`]: { mb: 2 } }}
      title={t('trainerSettings:title')}
    />
  );
};
